/**
* UAPP Core Optional Module
* @author NC
* UAPP Core Optionale Module, Komponenten, Provider und Deklarationen
* Zu verwendende Elemente müssen hier einkommentiert werden
*/

import { NgModule, APP_INITIALIZER, ErrorHandler, Type, ModuleWithProviders, Provider } from "@angular/core";

//Module
let imports: Array<Type<any> | ModuleWithProviders | any[]> = [
  //AgmCoreModule.forRoot(coreConfig.modules.agm.config), //Angular Google Maps
  //AgmSnazzyInfoWindowModule, // Angular Google Maps - Snazzy Info Window
]

//Exports
let exports_: Array<Type<any> | any[]> = [
  //AgmCoreModule, //Angular Google Maps
  //AgmSnazzyInfoWindowModule, // Angular Google Maps - Snazzy Info Window
];

//Provider
let providers: Provider[] = [

]

//Deklarationen
let declarations: Array<Type<any> | any[]> = []

//Modul
let ngModule: NgModule = {
  declarations: declarations,
  imports: imports,
  exports: exports_,
  providers: providers
}

@NgModule(ngModule)
export class CoreOptionalModule { }
